import { commonComponents as e } from "@/components/common";
import FooterButtons from "@/components/common/FooterButtons";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@patient-watch/ui/form";
import { Input } from "@patient-watch/ui/input";
import { zodResolver } from "@hookform/resolvers/zod";
import { createFileRoute } from "@tanstack/react-router";
import { type SubmitHandler, useForm } from "react-hook-form";
import { toast } from "@patient-watch/ui/sonner";
import { useToastCopy } from "@/features/i18n/toastCopy";
import * as z from "zod";

const formSchema = z.object({
    name: z.string().min(1, "Name is required"),
    email: z.string().email("Invalid email").min(1, "Email is required"),
    day: z.number().gte(1, "Day is required").lte(31, "Max 31 days in a month"),
    month: z.number().gte(1, "Month is required").lte(12, "Only 12 months in a year"),
    year: z.number().gte(1900, "You're not that old!").lte(2005, "Over 18s only!"),
});

interface newPatientI {
    name: string;
    email: string;
    dob: Date;
}

const NewPatient = () => {
    const toastCopy = useToastCopy();
    type FormSchemaType = z.infer<typeof formSchema>;

    const form = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        defaultValues: {
            name: "",
            email: "",
        },
    });

    const addNewPatient = async (formData: newPatientI) => {
        console.log(formData);
        // const { data, error } = await supabase
        //     .from('patients') //table name
        //     .upsert({
        //         name: formData.name,
        //         email: formData.email,
        //     })
        //     .select()
        //     .single();
    };

    const onSubmit: SubmitHandler<FormSchemaType> = (data) => {
        const dob = new Date(data.year, data.month - 1, data.day);
        addNewPatient({
            name: data.name,
            email: data.email,
            dob: dob,
        });
        toast.success(toastCopy.patientAddedSuccess);
    };

    return (
        <>
            <e.Title words="New Patient" />
            <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
                    <FormField
                        control={form.control}
                        name="name"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Name</FormLabel>
                                <FormControl>
                                    <Input placeholder="Patient name" {...field} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={form.control}
                        name="email"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Email</FormLabel>
                                <FormControl>
                                    <Input placeholder="Patient email" {...field} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <div className="gap-4 grid grid-cols-3">
                        <FormField
                            control={form.control}
                            name="day"
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel>Day</FormLabel>
                                    <FormControl>
                                        <Input type="number" placeholder="DD" {...field} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        <FormField
                            control={form.control}
                            name="month"
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel>Month</FormLabel>
                                    <FormControl>
                                        <Input type="number" placeholder="MM" {...field} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        <FormField
                            control={form.control}
                            name="year"
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel>Year</FormLabel>
                                    <FormControl>
                                        <Input type="number" placeholder="YYYY" {...field} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                    </div>
                    <FooterButtons
                        func1={() => form.handleSubmit(onSubmit)()}
                        words1="Add Patient"
                        icon1={
                            <div className="flex justify-center items-center ml-[2px] p-[6px] w-8 h-8 rotate-180">
                                <e.icons.BackArrow fill="white" />
                            </div>
                        }
                    />
                </form>
            </Form>
        </>
    );
};

export const Route = createFileRoute("/_app/foot-watch/$diaryId/new/new-patient")({
    component: NewPatient,
});
